// @flow

export default {
  get: ('get': 'get'),
  post: ('post': 'post'),
  put: ('put': 'put'),
  delete: ('delete': 'delete'),
  patch: ('patch': 'patch'),
};
